import { useMemo } from 'react';

const useOrderStats = (orders = []) => {
  return useMemo(() => {
    const total = orders.length;
    const pending = orders.filter(order => order.status === 'pending').length;
    const confirmed = orders.filter(order => order.status === 'confirmed').length;
    const toContact = orders.filter(order => !order.lastContactDate).length;
    const totalAmount = orders.reduce((sum, order) => sum + (order.totalPrice || 0), 0);
    const savings = confirmed * 3500; // 3500 DA économisés par commande confirmée

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const todayOrders = orders.filter(order => {
      const orderDate = order.createdAt?.seconds 
        ? new Date(order.createdAt.seconds * 1000) 
        : new Date(order.createdAt);
      return orderDate >= today;
    }).length;

    return {
      // Stats pour le tableau de bord
      pendingOrders: pending,
      confirmationRate: total ? Math.round((confirmed / total) * 100) : 0,
      conversionRate: total ? Math.round((confirmed / total) * 100) : 0, 
      toContact,
      savings,
      totalRevenue: totalAmount,
      averageOrderValue: total > 0 ? totalAmount / total : 0,

      // Stats supplémentaires pour la page des commandes
      total,
      totalAmount,
      todayOrders,
      confirmed,
      totalOrders: total 
    };
  }, [orders]);
};

export default useOrderStats;
